import React from "react";
import "./styles/preview-routes.css";
//Assets
import Communities from "../../assets/images/Communities.webp";
import ProfileCommunity from "../../assets/images/profileCommunity.webp";
import CardCommunity from "../../assets/images/CommunitiesCard.webp";
import CardRoute from "../../assets/images/cardRoute.webp";
import InitRoute from "../../assets/images/initRoute.webp";
import CardRadarOfferts from "../../assets/images/OfertasRadariaCard.webp";
import Offerts from "../../assets/images/OfertasRadaria.webp";
import ViewOffert from "../../assets/images/viewOffert.webp";
import CardProgress from "../../assets/images/CardUserProgress.png";
import ProfileUserProgress from "../../assets/images/ProfileUser.png";

const PreviewRoutes = () => {
  return (
    <section className="wrap-preview-routes gap-5">
      <div>
        <aside>
          <h3 className="text-primary">Únete a comunidades.</h3>
          <p className="text-info">
            Haz que cada kilómetro cuente: rastrea tu progreso y supera tus
            límites.
          </p>
          <article>
            <div>
              <img
                src={ProfileCommunity}
                alt="Perfil de comunidad"
                width={150}
              />
              <img src={CardCommunity} alt="Comunidad" width={150} />
            </div>
            <div>
              <img src={Communities} alt="Map of users" width={200} />
            </div>
          </article>
        </aside>
        <aside>
          <h3 className="text-primary">Crea rutas personalizadas.</h3>
          <article>
            <div className="d-flex flex-column">
              <img src={CardRoute} alt="Route of Chapu" width={220} />
              <img src={CardRoute} alt="Route of Polanco" width={220} />
              <img src={CardRoute} alt="Route of Polanco" width={220} />
            </div>
            <div>
              <img
                src={InitRoute}
                alt="Profile of Routes of usuario"
                className="rounded"
                width={200}
              />
            </div>
          </article>
        </aside>
      </div>
      <div>
        <aside>
          <h3 className="text-primary"> Consigue descuentos especiales. </h3>
          <article>
            <div>
              <img src={ViewOffert} alt="Radar Point Sotelo" width={180} />
              <img
                src={CardRadarOfferts}
                alt="Radar Point Running"
                width={180}
              />
            </div>
            <div>
              <img
                src={Offerts}
                alt="Profile of Routes of usuario Radar Points"
                width={200}
              />
            </div>
          </article>
        </aside>
        <aside>
          <h3 className="text-primary">Sigue tu proceso.</h3>
          <article>
            <img src={CardProgress} alt="Card your progress" />
            <img
              src={ProfileUserProgress}
              alt="Profile of User of his progress"
            />
          </article>
        </aside>
      </div>
    </section>
  );
};
export default PreviewRoutes;
